export default __webpack_public_path__ + "static/media/deepdao_footer_logo.7d5a18f3.svg";